// extracted by mini-css-extract-plugin
export var aiStarSpin = "_m7-1";
export var spinner = "_m7-0";